var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "full-screen-modal",
      attrs: {
        id: "StripePaymentModal",
        centered: "",
        "hide-header": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return undefined
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "d-flex w-100" },
                [
                  _vm.stripeElementReady
                    ? _c(
                        "b-button",
                        {
                          staticClass: "w-100 mr-2 d-md-block",
                          attrs: {
                            disabled: _vm.isLoading,
                            variant: "secondary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              !_vm.isLoading
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "align-self-center mt-small-px"
                                    },
                                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                                  )
                                : _c("b-spinner", {
                                    staticClass: "button-spinner"
                                  })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.stripeElementReady
                    ? _c(
                        "b-button",
                        {
                          staticClass: "w-100 mr-2 d-md-block",
                          attrs: {
                            disabled: _vm.isLoading,
                            variant: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleSubmit()
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              !_vm.isLoading
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "align-self-center mt-small-px"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          (_vm.isInstantPayment
                                            ? _vm.$t("stripe.pay")
                                            : _vm.$t("stripe.caution")) +
                                            " " +
                                            _vm.total +
                                            "€"
                                        )
                                      )
                                    ]
                                  )
                                : _c("b-spinner", {
                                    staticClass: "button-spinner"
                                  })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        [
          _c("StripeElementPayment", {
            ref: "stripePayment",
            attrs: {
              "confirm-params": _vm.confirmParams,
              "elements-options": _vm.elementsOptions,
              pk: _vm.stripePk,
              "test-mode": _vm.testMode === "development",
              redirect: "if_required"
            },
            on: {
              error: _vm.handleErrors,
              loading: _vm.handleLoading,
              "element-ready": _vm.handleElementReady
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eeb66b9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeb66b9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/annonce/StripePaymentModal.vue
// module id = jqea
// module chunks = 0